module.exports = __webpack_public_path__ + "img/contactUs.d9a15476.png";